import { env } from './env';

export function preconnectBackendOrigins() {
  if (typeof document === 'undefined' || typeof window === 'undefined') {
    return;
  }

  const documentHead = document.head;

  if (documentHead === null) {
    return;
  }

  const currentOrigin = window.location.origin;
  const backendOrigins = readBackendOrigins({
    currentOrigin,
  });

  for (const origin of backendOrigins) {
    if (
      hasPreconnectLink({
        documentHead,
        href: origin,
      })
    ) {
      continue;
    }

    const preconnectLink = document.createElement('link');
    preconnectLink.crossOrigin = '';
    preconnectLink.href = origin;
    preconnectLink.rel = 'preconnect';
    documentHead.append(preconnectLink);
  }
}

function hasPreconnectLink(input: {
  documentHead: HTMLHeadElement;
  href: string;
}) {
  return (
    input.documentHead.querySelector(
      `link[rel="preconnect"][href="${input.href}"]`,
    ) !== null
  );
}

function readBackendOrigins(input: { currentOrigin: string }) {
  const origins = new Set<string>();

  for (const backendUrl of [
    env.VITE_API_BASE_URL,
    env.VITE_MARKET_FEED_BASE_URL,
  ]) {
    const backendOrigin = new URL(backendUrl).origin;

    if (backendOrigin === input.currentOrigin) {
      continue;
    }

    origins.add(backendOrigin);
  }

  return [...origins];
}
